import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useCurrentUserAccess } from '@/store/currentUser';

export const ManagerRoute = (): JSX.Element => {
  const { isManager } = useCurrentUserAccess();
  const location = useLocation();

  if (!isManager) {
    return <Navigate to={{ pathname: '/' }} state={{ from: location }} />;
  }

  return <Outlet />;
};
